export const environment = {
  production: false,
  // apiV3Url: `${window.location.protocol}//10.0.80.204:9090`
  // apiV3Url: location.protocol+"//"+location.hostname+":9090"
  //  apiV3Url: 'http://10.0.80.204:9090',
  //   apiV3Url: 'https://homolog.umove-back.cloudmg.mg.gov.br',
  //  ucloudBackdoor: 'https://homolog.portal.cloudmg.mg.gov.br'
  // apiV3Url: 'http://teste.umove-back.cloudmg.mg.gov.br'

  apiV3Url: getApiUrl(),
  ucloudBackdoor: getUcloudBackdoor(),

  // ###################### AMBIENTE DEV ############################
  //  apiV3Url: 'http://localhost:9090',
  //  ucloudBackdoor: 'https://teste-marcel.usto.re',

  // ###################### AMBIENTE DEMO ############################
  // apiV3Url: "https://demo-backend.usto.re",
  // ucloudBackdoor: "https://demo-ucloud.usto.re",

  // ###################### AMBIENTE PROD PRODEMGE ############################
  // apiV3Url: 'https://umoveback.prodemge.gov.br',
  // ucloudBackdoor: 'https://nuvem.prodemge.gov.br',

  // ###################### AMBIENTE PROD #############################
  //  apiV3Url: 'https://umove-backend.usto.re',
  //  ucloudBackdoor: 'https://teste-marcel.usto.re',

  // ###################### AMBIENTE PROD COM UCLOUD DA PRODEB ############################
  //  apiV3Url: 'https://umove-backend.usto.re',
  //  ucloudBackdoor: 'https://pmc-prodeb.usto.re'
};

// Função para obter a URL da API com base no hostname
function getApiUrl(): string {
  switch (window.location.hostname) {
    case "localhost":
      return "http://localhost:9090";

    case "demo-umove.usto.re":
      return "https://demo-backend.usto.re";
   
    case "umove.prodemge.gov.br":
      return "https://umoveback.prodemge.gov.br";
   
    case "umove.usto.re":
      return "https://umove-backend.usto.re";
    
    // #############################################################
    // Adicione mais casos conforme necessário para outros hostnames

    
    default:
      return "https://umove-backend.usto.re";
  }
}

// Função para obter o backdoor do Ucloud com base no hostname
function getUcloudBackdoor(): string {
  switch (window.location.hostname) {
    case "localhost":
      return "https://teste-marcel.usto.re";
   
    case "demo-umove.usto.re":
      return "https://demo-ucloud.usto.re";
   
    case "umove.prodemge.gov.br":
      return "https://nuvem.prodemge.gov.br";
   
    case "umove.usto.re":
      // return "https://teste-marcel.usto.re";
      return "https://pmc-prodeb.usto.re";
    
    // #############################################################
    // Adicione mais casos conforme necessário para outros hostnames


    default:
      return "https://teste-marcel.usto.re";
  }
}
